import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

export const squareReservedKeys: string[] = ['host', 'clientId', 'clientSecret', 'accessToken', 'refreshToken', 'useEncryptedEndpoints', 'useHostVerification', 'usePeerVerification', 'encryptedCredential'];

@Metamodel.model({
    name: 'Square',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Square_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Square_DisplayText)
    ]
})
export class SquareLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RedirectUri
    })
    public redirectUri?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AccessToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public accessToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    public isOldResource?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): SquareLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as SquareLinkedService;
    }
}
